import { Link } from "react-router-dom";

const stats = [
  { value: "24h", label: "实时更新" },
  { value: "6+", label: "内容领域" },
  { value: "1000+", label: "独家线索" },
  { value: "365天", label: "持续跟进" },
];

export default function BrandIntro() {
  return (
    <section className="mt-14 w-full bg-primary-950 py-14">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-accent-400">
              <i className="ri-flashlight-line"></i>
              关于 91爆料
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black leading-tight text-background-50 md:text-3xl">
              直击内幕，做有温度的新闻
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300 md:text-base">
              91爆料是一个聚焦社会热点与深度独家爆料的新闻资讯平台。我们坚持快速、真实、有深度的内容标准，覆盖娱乐、时政、科技、社会、财经与体育等多个领域，
              为关注新闻时效与内容质量的读者，提供清晰、易读的每日报道。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
              >
                了解我们
              </Link>
              <Link
                to="/contact"
                className="cursor-pointer whitespace-nowrap rounded-md border border-background-50/25 px-5 py-2.5 text-sm font-medium text-background-100 transition-colors hover:bg-background-50/10"
              >
                提供线索
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg border border-background-50/10 bg-background-50/5 p-5">
                <div className="font-heading text-2xl font-black text-accent-400 md:text-3xl">{s.value}</div>
                <div className="mt-1 text-sm text-background-300">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}